import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/routes',
    name: 'Routes',
    component: () => import('@/views/Routes.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/leaders',
    name: 'Leaders',
    component: () => import('@/views/Leaders.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import('@/views/Orders.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('@/views/Reports.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('@/views/Users.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/Settings.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/route-form',
    name: 'RouteForm',
    component: () => import('@/views/RouteForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/vehicle-config',
    name: 'VehicleConfig',
    component: () => import('@/views/VehicleConfig.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/dict-config',
    name: 'DictConfig',
    component: () => import('@/views/DictConfig.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new Router({
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 页面刷新时滚动到顶部
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token')
    if (!token) {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
